<template>
  <span class="font-weight-bold">{{ inventoryInfo.current_inventory }}</span>
  <span v-if="inventoryInfo.incoming_inventory"> in:{{ inventoryInfo.incoming_inventory }}</span>
  <span v-if="inventoryInfo.outgoing_inventory"> out:{{ inventoryInfo.outgoing_inventory }}</span>
</template>

<script>

  export default {
    props: {
      inventoryInfo: Array,
    },
  }
</script>